define(['jquery'],
	function($) {
		var eventForms = {
            Init: function () {
                eventForms.eventSelect();
            },
            eventSelect: function(){
                //pre-populate event demos based on button selected
                //in sitecore, data-event must be added to the button
                if($('[data-event]').length){
                    $('[data-event]').on('click', function(e){
                        var demoTopic = $(this).attr('data-event');
                        $('.event-select select').val(demoTopic);
                        e.preventDefault;
                    });
                }
            },
        }
        return eventForms;
	}	
);
    